module.exports = __webpack_public_path__ + "img/protected-bag-icon-5.f8a29c95.svg";